const StaticRoles = Object.freeze({
  ADMIN: "admin",
  ADVISOR: "advisor",
  SUPERVISOR: "supervisor",
  EMPLOYEE: "employee",
  CLIENT: "client",
});

export default StaticRoles;